import Api from "@/services/apiService";

// API сохранённых версий ПЛАНа заказа. Сам расчёт выполняет backend-калькулятор.
class OrderCalculationsApi {
  index(companyId, orderId, page = 1) {
    return Api.getRequest(
      `companies/${companyId}/orders/${orderId}/calculations`,
      { calculation_type: "plan", page },
      Api.authHeaders()
    );
  }

  fact(companyId, orderId) {
    return Api.getRequest(
      `companies/${companyId}/orders/${orderId}/calculations/fact`,
      {},
      Api.authHeaders()
    );
  }

  updateFactMileage(companyId, orderId, actualMileageKm) {
    return Api.patchRequest(
      `companies/${companyId}/orders/${orderId}/calculations/fact`,
      { actual_mileage_km: actualMileageKm },
      Api.authHeaders()
    );
  }

  refreshFactMileage(companyId, orderId) {
    return Api.postRequest(
      `companies/${companyId}/orders/${orderId}/calculations/fact/refresh`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, orderId, calculatorPresetId, presetParams = []) {
    return Api.postRequest(
      `companies/${companyId}/orders/${orderId}/calculations`,
      {
        calculator_preset_id: calculatorPresetId,
        preset_params: presetParams,
      },
      Api.authHeaders()
    );
  }
}

export default new OrderCalculationsApi();
